import store from './store';

export default ({ status, cacheKey }) => store.dispatch({
  type: `${cacheKey}:STATUS`,
  payload: status,
});
